import { createScreenView, SCREEN_VIEWS } from '@/global/composables/table/useScreenView'

/**
 * How the requests listing splits the screen with the map.
 *
 * Opens on the full-width table: the map is only worth the room once requests are
 * being picked, and even then the design opens on the table.
 */
export const requestsScreenView = createScreenView({
  initialView: SCREEN_VIEWS.table
})
